import React, {useState} from "react";
import {Title} from "../../../../../../stories/Title/Title";
import Close from "../../../../../../images/Close.svg";
import WorkProgressItem, {
  projects,
  WorkProgressPageFor,
} from "../WorkProgressItem";
import View from "../../../../../../images/EyeWhite.svg";
import {CustomModal} from "../../../../../../utils/UtilFunctions";
import {AddModalStyles} from "../../../../../../styles/CustomModalStyles";
import ViewTableStructure from "../ViewTableStructure";
import {PageFor} from "../../../../../../utils/Enum.types";
import {Button} from "../../../../../../stories/Button/Button";
interface Props {
  setModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const CopyTableFormat = ({setModal}: Props) => {
  const [previewModal, setPreviewModal] = useState(false);
  return (
    <div className="copy-table-format">
      <div className="copy-table-format__title">
        <Title>Copy Project Table Format</Title>
        <img src={Close} alt="" onClick={() => setModal(false)} />
      </div>
      <div className="copy-table-format__block">
        {projects.map((res, index) => {
          return (
            <>
              <div className="copy-table-format__block--li">
                <WorkProgressItem
                  res={res as any}
                  index={index}
                  pageType={WorkProgressPageFor.COPY_TABLE_FORMAT}
                />
                <button
                  disabled={res.status === "Table Structure Not Added"}
                  className="copy-table-format__block--li--preview"
                  onClick={() => setPreviewModal(!previewModal)}
                >
                  Preview <img src={View} alt="" />
                </button>
              </div>
            </>
          );
        })}
      </div>
      <Button mode="cancel" onClick={() => setModal(false)} />
      <CustomModal
        style={AddModalStyles}
        isOpen={previewModal}
        onRequestClose={() => setPreviewModal(!previewModal)}
        contentComponent={
          <ViewTableStructure
            setModal={setPreviewModal}
            pageType={PageFor.MODAL}
          />
        }
      />
    </div>
  );
};

export default CopyTableFormat;
